import React from 'react'
import styled from 'styled-components'
import { Grid, H, P, BulletSeparator, EmailIcon } from '@farewill/ui'
import { GTR, FONT, COLOR } from '@farewill/ui/tokens'
import PropTypes from 'prop-types'

import { formattedOpenHours, formattedOpenDays } from 'lib/time/formatting'
import { GENERAL_EMAIL_ADDRESS, WILLS_TELEPHONE_NUMBER } from 'config'
import { WILLS } from 'lib/products/constants'
import Specialists from 'components/Specialists'
import PreventOrphan from 'components/PreventOrphan'
import TelephoneNumber from 'components/TelephoneNumber'

const StyledSupportOption = styled(BulletSeparator)`
  margin-bottom: ${GTR.S};

  & > *:first-child {
    font-weight: ${FONT.WEIGHT.BOLD};
    color: ${COLOR.BLACK};
  }
`

const StyledEmailSupportOption = styled.a`
  color: ${COLOR.BLACK};
  font-weight: ${FONT.WEIGHT.BOLD};

  svg {
    margin-right: 10px;
  }
`

const Support = ({ telephoneWillsEnabled = true }) => (
  <Grid gapFromL={0} style={{ alignItems: 'center' }}>
    <Grid.Item spanFromL={8} spanFromXL={7}>
      <H size="L" decorative>
        Specialists at your fingertips
      </H>

      <P>
        <PreventOrphan>
          Our team of specialists are here 7 days a week to help you make a will
          from the comfort of your own home. Whether you have a question about
          our will writing service or need help with a specific section, we’re
          only a message {telephoneWillsEnabled ? 'or phone call' : ''} away.
        </PreventOrphan>
      </P>

      <ul>
        <li>
          <StyledSupportOption>
            <span>
              <StyledEmailSupportOption
                href={`mailto:${GENERAL_EMAIL_ADDRESS}`}
                rel="noreferrer"
                target="_blank"
              >
                <EmailIcon inline />
                <span>Email us</span>
              </StyledEmailSupportOption>
            </span>
          </StyledSupportOption>
        </li>
        {telephoneWillsEnabled && (
          <li>
            <StyledSupportOption>
              <span>
                <TelephoneNumber
                  underline
                  telephoneNumber={WILLS_TELEPHONE_NUMBER}
                />
              </span>
              <span>{formattedOpenHours(WILLS)}</span>
              <span>{formattedOpenDays(WILLS)}</span>
            </StyledSupportOption>
          </li>
        )}
      </ul>
    </Grid.Item>

    <Grid.Item
      spanFromL={3}
      spanFromXL={4}
      startColumnFromL={10}
      startColumnFromXL={9}
    >
      <Specialists group={WILLS} />
    </Grid.Item>
  </Grid>
)

Support.propTypes = {
  telephoneWillsEnabled: PropTypes.bool,
}

Support.defaultProps = {
  telephoneWillsEnabled: true,
}

export default Support
